// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1795":"e1c941b0","5300":"f3effff8"}[chunkId] + ".chunk.css";
};